import React from "react";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

import arrow from "../../assets/images/slide-arrow.png";

// ✅ IMPORT ALL IMAGES
import hover1 from "../../assets/images/hover-image1.png";
import hover2 from "../../assets/images/hover-image2.png";
import hover3 from "../../assets/images/hover-image3.png";
import hover4 from "../../assets/images/hover-image4.png";
import hover5 from "../../assets/images/hover-image5.png";
import hover6 from "../../assets/images/hover-image6.png";

import arrow1 from "../../assets/images/arrow-slide1.png";
import arrow2 from "../../assets/images/arrow-slide2.png";
import arrow3 from "../../assets/images/arrow-slide3.png";
import arrow4 from "../../assets/images/arrow-slide4.png";
import arrow5 from "../../assets/images/arrow-slide5.png";
import arrow6 from "../../assets/images/arrow-slide6.png";

export default function WhySlider() {

    const settings = {
        arrows: false,
        dots: true,
        infinite: false,
    };

    const features = [
        { img: hover1, arrow: arrow1, label: "Professional" },
        { img: hover2, arrow: arrow2, label: "Timely Delivery" },
        { img: hover3, arrow: arrow3, label: "Affordability" },
        { img: hover4, arrow: arrow4, label: "Personalization" },
        { img: hover5, arrow: arrow5, label: "Innovation" },
        { img: hover6, arrow: arrow6, label: "Support" },
    ];

    return (
        <>
            <section className="why-slider">
                <Slider {...settings}>

                    {/* Slide 1 */}
                    <div className="slide slide-1">
                        <div className="content">
                            <div className="text-slide">
                                <h2>Why We’re the Right Choice ?</h2>
                                <p>
                                    We build digital experiences that drive growth. If you’re looking for reliable,
                                    innovative, and efficient IT solutions, you’re in the right place. We combine
                                    technical expertise with creative thinking to deliver digital solutions that work.
                                    Our team is committed to quality, communication, and results—every step of the way.
                                </p>
                            </div>
                            <div className="image-slider">
                                <img src={arrow} className="image-img" alt="Arrow" />
                            </div>
                        </div>
                    </div>

                    {/* Slide 2 */}
                    <div className="slide slide-2">
                        <div className="feature-grid">
                            {features.map((item, idx) => (
                                <div key={idx} className="feature-card has-hover-img">

                                    {/* ✅ FIX HERE */}
                                    <img src={item.img} alt={item.label} />

                                    <div className="icon-content">
                                        {/* ✅ FIX HERE */}
                                        <img src={item.arrow} alt="Icon" />
                                        <span>{item.label}</span>
                                    </div>

                                </div>
                            ))}
                        </div>
                    </div>

                </Slider>
            </section>

            {/* MOBILE */}
            <section>
                <div className="Mobile-view">

                    <div className="slide slide-1">
                        <div className="content">
                            <div className="text-slide">
                                <h2>Why We’re the Right Choice ?</h2>
                                <p>
                                    We build digital experiences that drive growth...
                                </p>
                            </div>
                            <div className="image-slider">
                                <img src={arrow} className="image-img" alt="Arrow" />
                            </div>
                        </div>
                    </div>

                    <div className="slide slide-2">
                        <div className="feature-grid">
                            {features.map((item, idx) => (
                                <div key={idx} className="feature-card has-hover-img">

                                    {/* ✅ FIX HERE */}
                                    <img src={item.img} alt={item.label} />

                                    <div className="icon-content">
                                        {/* ✅ FIX HERE */}
                                        <img src={item.arrow} alt="Icon" />
                                        <span>{item.label}</span>
                                    </div>

                                </div>
                            ))}
                        </div>
                    </div>

                </div>
            </section>
        </>
    );
}